import { createComponent as S, mergeProps as O, setAttribute as E, insert as k, spread as X, template as j } from "solid-js/web";
import { createSignal as u, Show as C } from "solid-js";
import { convertDateObjectToDate as p, labelFormat as n } from "../../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/utils.js";
import { DatePicker as G } from "../DatePicker/index.js";
import { Popover as N } from "../Popover/index.js";
import { defaultSelectorProps as I } from "../SelectorTwo/index.js";
import { cn as P } from "../../utils/class.js";
var U = j('<input readonly type=text data-scope=date-picker data-part=input aria-label="date picker input"data-type=date-picker-input>'), V = j("<div class=date-picker-input-area data-scope=date-picker data-part=control>");
const Z = (e) => {
  const [m, x] = u({ label: "", value: {} }), [L, h] = u(!1), [R, v] = u([]), [T, y] = u(!1), [Y, D] = u(I), [A, F] = u(null), W = (t) => {
    const l = e.value || m, o = e.setValue || x;
    if (t.type === "single") {
      const a = p((t == null ? void 0 : t.selectedDate) || {}), r = n({ date: a, option: (e == null ? void 0 : e.localeOptions) || { month: "short", day: "numeric", year: "numeric" }, format: e.formatInputLabel, locale: e.locale });
      o({ value: { selected: (a == null ? void 0 : a.toISOString()) || "", selectedDateObject: (t == null ? void 0 : t.selectedDate) || {} }, label: r });
    }
    if (t.type === "range") {
      const a = t.startDate ? p(t.startDate) : void 0, r = t.endDate ? p(t.endDate) : void 0;
      let f = "";
      const c = { month: "short", day: "numeric", year: "numeric", ...(e == null ? void 0 : e.localeOptions) || {}, ...e != null && e.alwaysShowRangeStartYear ? {} : { year: void 0 } }, s = (e == null ? void 0 : e.localeOptions) || { month: "short", day: "numeric", year: "numeric" };
      let i = "", d = "";
      if (a && r) {
        if (a.getFullYear() === r.getFullYear()) {
          if (e.alwaysShowRangeStartYear)
            return;
          c.year = void 0;
        } else
          c.year = "numeric";
        i = n({ date: a, option: c, format: e.formatInputLabelRangeStart, locale: e.locale }), d = n({ date: r, option: s, format: e.formatInputLabelRangeEnd, locale: e.locale });
      }
      a && !r && (i = n({ date: a, option: c, format: e.formatInputLabelRangeStart, locale: e.locale })), !a && r && (d = n({ date: r, option: s, format: e.formatInputLabelRangeEnd, locale: e.locale })), f = `${i} ${e.rangeDatesSeparator || "-"} ${d}`, o({ value: { start: (a == null ? void 0 : a.toISOString()) || "", startDateObject: (t == null ? void 0 : t.startDate) || {}, end: (r == null ? void 0 : r.toISOString()) || "", endDateObject: (t == null ? void 0 : t.endDate) || {} }, label: f });
    }
    if (t.type === "multiple") {
      const a = l().value.multipleDateObject || [], r = t.multipleDates || [];
      if (!l().label && r.length === 0 || a.toString() === r.toString() && l().label)
        return;
      const f = r.map((s) => {
        const i = p(s);
        return n({ date: i, option: (e == null ? void 0 : e.localeOptions) || { month: "short", day: "numeric", year: "numeric" }, format: e.formatInputLabel, locale: e.locale });
      }), c = r.map((s) => {
        var i;
        return ((i = p(s)) == null ? void 0 : i.toISOString()) || "";
      }).sort((s, i) => s.localeCompare(i));
      o({ value: { multiple: c, multipleDateObject: r.sort((s, i) => {
        var b, w;
        const d = ((b = p(s)) == null ? void 0 : b.toISOString()) || "", z = ((w = p(i)) == null ? void 0 : w.toISOString()) || "";
        return d.localeCompare(z);
      }) }, label: f.join(e.multipleDatesSeparator || ", ") });
    }
  }, $ = () => {
    h(!0);
  }, g = ((t) => {
    if (t)
      return typeof t == "function" ? t({ value: e.value || m, showDate: $ }) : t;
  })(e.renderInput);
  return S(N, { get isShown() {
    return L();
  }, setIsShown: h, onClose: () => {
    var t;
    v([]), y(!1), D(I), (t = e.onClose) == null || t.call(e);
  }, onOpen: () => {
    var t;
    (t = e.onOpen) == null || t.call(e);
  }, content: ({ close: t }) => S(G, O(e, { get type() {
    return e.type || "single";
  }, get value() {
    var l, o;
    return ((o = (l = e.value) == null ? void 0 : l.call(e)) == null ? void 0 : o.value) || m().value;
  }, handleOnChange: W, get onChange() {
    return e.onChange;
  }, get maxDate() {
    return e.maxDate;
  }, get minDate() {
    return e.minDate;
  }, setAllowedComponents: v, close: t, get yearSelectorCount() {
    return e.yearSelectorCount || 20;
  }, setShowSelectorTwo: y, showSelectorTwo: T, setSelectorTwoProps: D, selectorTwoProps: Y, ref: A, get locale() {
    return e.locale || "en-US";
  }, setRef: F })), onClickOutside: (t, l) => {
    var o;
    (o = R().concat(e.componentsToAllowOutsideClick || [])) != null && o.some((a) => {
      var r;
      return (r = a == null ? void 0 : a.contains) == null ? void 0 : r.call(a, t == null ? void 0 : t.target);
    }) || (l == null || l(!1));
  }, get positionX() {
    return e.pickerPositionX;
  }, get positionY() {
    return e.pickerPositionY;
  }, get zIndex() {
    return e.zIndex;
  }, handleChildrenClick: g ? () => {
  } : void 0, get width() {
    return e.inputWrapperWidth;
  }, get className() {
    return P(e.inputWrapperClass, "date-picker-input-wrapper");
  }, get children() {
    var t = V();
    return E(t, "data-date-picker-input-area", !0), k(t, S(C, { when: g, keyed: !0, children: g }), null), k(t, S(C, { when: !g, keyed: !0, get children() {
      var l = U();
      return X(l, O({ get placeholder() {
        return e.placeholder;
      }, get value() {
        var o, a, r;
        return ((o = e.inputLabel) == null ? void 0 : o.call(e)) || ((r = (a = e.value) == null ? void 0 : a.call(e)) == null ? void 0 : r.label) || m().label;
      } }, () => ({ ...e.inputProps, class: void 0 }), { get class() {
        var o;
        return P("date-picker-input rn-w-full rn-px-1", (o = e.inputProps) == null ? void 0 : o.class, e.inputClass);
      } }), !1, !1), l;
    } }), null), t;
  } });
};
export {
  Z as DatePickerGroup
};
